// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2_lPs","title":"index-module--title--3OTnt","body":"index-module--body--2gTAR","button":"index-module--button--3eIoy"};